import { post, Response } from '@/api'
import { EmailPostDto } from '@/types/index'

export default {
  sendEssentialShopActivationRequest: (emailAddress: string): Promise<Response<string>> => {
    return post<string, EmailPostDto>('/guest/essential-shop', { email: emailAddress })
  }
}
